export default "__VITE_ASSET__f2d6f4fa__"